<template>
  <div>
    <v-row>
      <v-col class="col-12 col-sm-12 col-md-3 side-bar order-first order-md-last">
        <right-menu></right-menu>
      </v-col>
      <v-col class="col-12 col-sm-12 col-md-9">
        <div v-if="context">
          <div class="article-title mainTitle" v-html="context.title"></div>
          <div class="article-title subTitle" v-if="context.subTitle" v-html="context.subTitle"></div>
          <div class="article-title family mb-1" v-if="context.family" v-html="context.family"></div>

          <div class="issue-page-author-panel mt-2">
            <div v-if="issue && issue.url">
              <span class="label">ISSUE: </span>
              <span class="issue-nav">
                                <router-link :to="getURLLocalGlobal(issue.url)" class=""
                                             @click="goToPage(issue.url, $event)">
                                    {{ issue.name }}
                                </router-link>
                            </span>
            </div>
            <div class="" v-if="context.pages">
              <span class="label">Page: </span>
              <span class="light-text">{{ context.pages }} </span>
            </div>
            <div class="" v-if="context.authors && context.authors.length">
              <span class="label">By </span>
              <span class="auth-name">
                                <span v-for="(author, au) in context.authors" :key="au">
                                    <router-link :to="getURLLocalGlobal(author.url)" class=""
                                                 @click="goToPage(author.url, $event)">
                                        <strong>{{ author.name | formatAuthorName }}</strong>
                                    </router-link><span
                                    v-if="context.authors.length > 1 && context.authors.length - 1 !== au ">, </span>
                                </span>
                            </span>
            </div>

          </div>
          <br>
          <div class="hgArticle" v-html="context.body"></div>
        </div>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import globalMixins from "@/mixins/globalMixins";
import RightMenu from "@/views/partials/common/hgRightMenu.vue";

export default {
  name: 'articlePage',

  mixins: [globalMixins],

  components: {
    RightMenu
  },

  data() {
    return {
      issue: {}
    }
  },

  props: {
    pageId: {
      type: [Number, String]
    },
    context: {
      type: Object
    }
  },

  computed: {},

  async created() {
    if (this.context) {
      if (this.context.paths) {
        this.issue = this.context.paths[3];
      }
      await this.init();

      this.$store.dispatch('breadCrumbs/set', {text: this.context.title});
    }

  },

  methods: {
    async init() {
      if (this.context.authors && this.context.authors.length) {
        for (let x = 0; x < this.context.authors.length; x++) {
          let fullName = `${this.context.authors[x].firstName} ${this.context.authors[x].lastName}`;
          if (this.context.authors[x].honorifics) {
            fullName += ` ${this.context.authors[x].honorifics}`;
          }
          this.context.authors[x].fullName = fullName;
        }
      }
    },

  }
}
</script>

<style type="text/css" scoped>

.hgArticle {
  word-break: break-word;
}

.article-title, .article-title >>> p {
  font-size: 20px !important;
  font-family: "Roboto Condensed", sans-serif;
  color: #000;
  padding-right: 8px;
  margin-bottom: 0px !important;
}

.article-title.mainTitle, .article-title.mainTitle >>> p {
  font-weight: bold !important;
}

.article-title.subTitle {
}

.article-title.family {
}

/*.article-subTitle, .article-family {
    font-size: 20px;
    font-family: "Roboto Condensed", sans-serif;
    color: #000;
    padding-right: 8px;
}

    .article-subTitle >>> p, .article-family >>> p {
        font-size: 20px;
        font-family: "Roboto Condensed", sans-serif;
        color: #000;
        margin-bottom: 4px !important;
    }*/

.issue-page-author-panel {
  font-size: 13px;
  color: #7A7A7A;
}

.issue-page-author-panel >>> .label {
  font-weight: 600;
}

</style>
